// extracted by mini-css-extract-plugin
export var notificationHost = "_ce-0";